import request from "../utils/request";

export const CUSTOM_BLOCKS_API = {
    // List and search
    list(filters = {}) {
        return request.get("/chatbot/custom-blocks", {
            params: filters,
        });
    },
    
    getMyBlocks() {
        return request.get("/chatbot/custom-blocks/my-blocks");
    },
    
    getImported() {
        return request.get("/chatbot/custom-blocks/imported");
    },
    
    getPendingApproval() {
        return request.get("/chatbot/custom-blocks/pending-approval");
    },
    
    // Block details
    getDetails(id, includeCode = false) {
        return request.get(`/chatbot/custom-blocks/${id}`, {
            params: { includeCode },
        });
    },
    
    // Versions
    getVersions(id) {
        return request.get(`/chatbot/custom-blocks/${id}/versions`);
    },
    
    getVersion(id, version) {
        return request.get(`/chatbot/custom-blocks/${id}/versions/${version}`);
    },
    
    // CRUD operations
    create(blockData) {
        return request.post("/chatbot/custom-blocks", blockData);
    },
    
    update(id, updates) {
        return request.put(`/chatbot/custom-blocks/${id}`, updates);
    },
    
    publish(id, changelog = "") {
        return request.post(`/chatbot/custom-blocks/${id}/publish`, { changelog });
    },
    
    unlist(id) {
        return request.post(`/chatbot/custom-blocks/${id}/unlist`);
    },
    
    delete(id) {
        return request.delete(`/chatbot/custom-blocks/${id}`);
    },
    
    // Import/Export
    import(id, versionId = null) {
        return request.post(`/chatbot/custom-blocks/${id}/import`, { versionId });
    },
    
    removeImport(id) {
        return request.delete(`/chatbot/custom-blocks/${id}/import`);
    },
    
    updateImportConfig(id, config) {
        return request.put(`/chatbot/custom-blocks/${id}/import/config`, config);
    },
    
    // Rating
    rate(id, rating, comment = "") {
        return request.post(`/chatbot/custom-blocks/${id}/rating`, { rating, comment });
    },
    
    getRatings(id) {
        return request.get(`/chatbot/custom-blocks/${id}/ratings`);
    },
    
    // Approval (admin only)
    approve(id) {
        return request.post(`/chatbot/custom-blocks/${id}/approve`);
    },
    
    reject(id, reason = "") {
        return request.post(`/chatbot/custom-blocks/${id}/reject`, { reason });
    },
};

